import type { GetMyPassengerResponse } from '@massilia/queries'

import { useGetMyPassengersQuery } from '@massilia/queries'
import { Button, Separator } from '@massilia/ui'
import { Loader2, Plus } from 'lucide-react'
import { useState } from 'react'

import { PassengerCard } from './passenger-card'
import { PassengerFormDialog } from './passenger-form-dialog'

export function PassengersSection() {
  const { data: passengers = [], isLoading } = useGetMyPassengersQuery()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [editingPassenger, setEditingPassenger] = useState<GetMyPassengerResponse | undefined>()

  const handleEdit = (passenger: GetMyPassengerResponse) => {
    setEditingPassenger(passenger)
    setIsDialogOpen(true)
  }

  const handleAdd = () => {
    setEditingPassenger(undefined)
    setIsDialogOpen(true)
  }

  const handleClose = () => {
    setIsDialogOpen(false)
    setEditingPassenger(undefined)
  }

  return (
    <>
      <div className="flex items-center justify-between">
        <h3 className="text-gray-light-900 text-base font-semibold">Passagers enregistrés</h3>
        <Button
          className="bg-brand-600 hover:bg-brand-700 gap-1 text-white"
          onClick={handleAdd}
          size="sm"
        >
          <Plus className="size-4" />
          Ajouter un passager
        </Button>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center py-8">
          <Loader2 className="text-brand-600 size-6 animate-spin" />
        </div>
      ) : passengers.length === 0 ? (
        <p className="text-gray-light-500 py-4 text-sm">
          Aucun passager enregistré. Ajoutez vos voyageurs fréquents pour pré-remplir vos
          réservations.
        </p>
      ) : (
        <div className="space-y-4">
          {passengers.map((passenger) => (
            <PassengerCard key={passenger.id} onEdit={handleEdit} passenger={passenger} />
          ))}
        </div>
      )}

      <Separator />

      <PassengerFormDialog
        isOpen={isDialogOpen}
        onClose={handleClose}
        passenger={editingPassenger}
      />
    </>
  )
}
